export default "__VITE_ASSET__a4e2f0f5__"